export default "__VITE_ASSET__gXlndz62__"